// extracted by mini-css-extract-plugin
module.exports = {"__start_button_outer":"startButton___start_button_outer__34IIt","__start_button":"startButton___start_button__PzTP6","__start_button_text":"startButton___start_button_text__2hoiP"};